import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import reportWebVitals from './utils/reportWebVitals';
import App from './App';

// import "./mocks";

// OAuth2 sign-in opens a popup that redirects back to this app's origin with
// `?code=...`. The opener (@okteto/react-oauth2-login) polls the popup's URL
// every 500ms to read that code. If we boot the SPA inside the popup, it can
// authenticate off a stale localStorage token and route away — replacing the
// URL and destroying `?code` before the poll fires. The login then resolves
// without a code and the user has to click "Log Masuk" again (and clearing
// localStorage "fixes" it, because then nothing routes away).
//
// So: when this window is an OAuth popup, render nothing and leave the URL
// untouched. The opener reads the code and closes the popup.
const oauthParams = new URLSearchParams(window.location.search);
const isOAuthPopup =
  typeof window !== 'undefined' &&
  window.opener &&
  window.opener !== window &&
  (oauthParams.has('code') || oauthParams.has('error'));

if (!isOAuthPopup) {
  ReactDOM.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
    document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
